module.exports = __webpack_public_path__ + "casting.772055595f67ec6d25f2d60aaa131062.gif";